<template>
  <div class="zong">
    <!-- <div class="echart-title">运营商数据</div> -->
    <div class="echart-progress">
      <el-progress type="dashboard" :percentage="usedFlow" :color="colors" :stroke-width="10"></el-progress>
    </div>
    <div class="dataZongClass" >
      <div class="dataClass">
        <span class="dot used-dot"></span>
        <span class="amount">{{usedPool}}</span>
        <p>已使用(MB)</p>
      </div>
      <div class="dataClass">
        <span class="dot surplus-dot"></span>
        <span class="amount">{{remainingPool}}</span>
        <p>剩余(MB)</p>
      </div>
      <div class="dataClass">
        <span class="dot surplus-card"></span>
        <span class="amount">{{totalPoolFlow}}</span>
        <p>池总量(MB)</p>
      </div>
      <div class="dataClass">
        <span class="dot surplus-card"></span>
        <span class="amount">{{totalCount}}</span>
        <p>池总数</p>
      </div>
      <div class="dataClass">
        <span class="dot surplus-card"></span>
        <span class="amount">{{totalCard}}</span>
        <p>总卡数</p>
      </div>
    </div>
  </div>
</template>
<script>
import { smallCardPoolUse } from "@/api/api.js";//小流量数据
export default {
  props:{
    groupId:{
      type:String,
      require:true
    }
  },
  data() {
    return {
      totalPoolFlow:0,
      usedPool:0,
      remainingPool:0,
      usedFlow:0,
      totalCount:0,
      totalCard:0,
      colors: [
        {color: '#6f7ad3', percentage: 20},
        {color: '#e6a23c', percentage: 40},
        {color: '#5cb87a', percentage: 60},
        {color: '#1989fa', percentage: 80},
        {color: '#f56c6c', percentage: 100}
      ]
    };
  },
  methods: {
    smallFlow(refresh){
      let params = {groupId:this.groupId,refresh}
      smallCardPoolUse(params).then(res =>{
        this.totalPoolFlow = res.data.data.totalPoolFlow.toFixed(2);
        this.usedPool = res.data.data.usedPoolFlow.toFixed(2);
        this.totalCount = res.data.data.totalCount;
        this.totalCard = res.data.data.totalCard;
        this.remainingPool = (this.totalPoolFlow - this.usedPool).toFixed(2);
        if(this.totalPoolFlow == 0){
          this.usedFlow = 0;
        }else{
          this.usedFlow = Number(this.formatDecimal(this.usedPool / this.totalPoolFlow * 100,2));
        };
      })
    },
    // 截取小数点的方法
    formatDecimal(num, decimal) {
      num = num.toString()
      let index = num.indexOf('.')
      if (index !== -1) {
          num = num.substring(0, decimal + index + 1)
      } else {
          num = num.substring(0)
      }
      return parseFloat(num).toFixed(decimal)
    },
  },
  mounted() {
    this.smallFlow(0);
  },
};
</script>
<style scoped lang="less">

  .zong{
    width: 100%;
    height: 280px;
    background: #fff;
    text-align: center;
    border-radius: 8px;
    .echart-title{
      text-align:left;
      font-size: 18px;
      color: #333;
      font-weight: bolder;
      font-family: sans-serif;
      font-style: normal;
      margin-left: 22px
    }
  }
  .echart-progress{
    width: 100%;
    height: 210px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .dataZongClass{
    display: flex;
    justify-content: center;
  }
  .dataClass{
    width: 30%;
    height: 70px;
    .dot{
      width: 10px;
      height: 10px;
      display: inline-block;
      border-radius: 50%;
    }
    .amount{
      margin-left: 16px;
      font-size: 15px;
    }
    p{
      font-size: 14px;
      text-indent: 20px;
    }
  }
  .used-dot{
    background:#fca21d;
  }
  .surplus-dot{
    background: #d9e2ec;;
  }
  .surplus-card{
    background: #91CC75;
  }
  /deep/ .el-progress-circle{
    height: 170px !important;
    width: 170px !important;
  }
</style>


